import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { func, bool } from 'prop-types';
import { translate } from 'react-i18next';
import { SocialWidget } from '@snapask/common-components';

import { getIsSocialWidgetOpen, actions } from '@blueberry/redux/socialWidget';
import { sendGTMEvent } from '@blueberry/redux/googleTagManager';
import {
  WIDGET_CLICK,
  WIDGET_CTA_CLICK,
} from '@blueberry/constants/gtmVariables';
import { getRegion } from '@blueberry/redux/locale';

const mapStateToProps = state => ({
  isSocialWidgetOpen: getIsSocialWidgetOpen(state),
  region: getRegion(state),
});

const SocialWidgetHandler = ({
  t,
  region,
  sendGTMEvent,
  isSocialWidgetOpen,
  toggleSocialWidget,
}) => {
  const handleChangeActive = () => {
    toggleSocialWidget();

    if (!isSocialWidgetOpen) {
      sendGTMEvent({
        eventName: WIDGET_CLICK,
        data: {
          region,
        },
      });
    }
  };

  const handleClickContactUsButton = () => {
    sendGTMEvent({
      eventName: WIDGET_CTA_CLICK,
      data: {
        region,
      },
    });
  };

  return (
    <SocialWidget
      t={t}
      isActive={isSocialWidgetOpen}
      onChangeActive={handleChangeActive}
      onClickContactUsButton={handleClickContactUsButton}
    />
  );
};

SocialWidgetHandler.propTypes = {
  isSocialWidgetOpen: bool.isRequired,
  region: func.isRequired,
  sendGTMEvent: func.isRequired,
  t: func.isRequired,
  toggleSocialWidget: func.isRequired,
};

export default compose(
  translate(['common']),
  connect(mapStateToProps, {
    sendGTMEvent,
    toggleSocialWidget: actions.toggleSocialWidget,
  })
)(SocialWidgetHandler);



// WEBPACK FOOTER //
// ./app/containers/SocialWidgetHandler/SocialWidgetHandler.jsx